import React, { useState } from "react";
import { AppHeader, AppFooter } from "../../components";
import { SearchBar } from "./components";

export default function HomePage() {
  const [searchVal, setSearchVal] = useState("");

  return (
    <>
      <AppHeader searchVal={searchVal} setSearchVal={setSearchVal} />
      <SearchBar />
      <AppFooter />
    </>
  );
}
